let ACCESS_TOKEN: string | null = null;

export const getAccessToken = () => {
  return ACCESS_TOKEN;
};

export const setAccessToken = (token: string | undefined) => {
  ACCESS_TOKEN = token ? token : '';
};
